import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;

// El backend valida el JWT en el handshake. Usamos función en vez de objeto
// para que el token se re-lea en cada (re)conexión — así un re-login no
// requiere refrescar la página para reconectar con credenciales frescas.
const socket = io(SOCKET_URL, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    auth: (cb) => cb({ token: localStorage.getItem('token') || '' }),
});

// Si el handshake falla por token (Unauthorized), evitamos un loop infinito
// de reconexión: tras varios intentos consecutivos, limpiamos el token y
// redirigimos a login para forzar credenciales frescas.
let unauthorizedAttempts = 0;
socket.on('connect', () => { unauthorizedAttempts = 0; });
socket.on('connect_error', (err) => {
    if (String(err?.message || '').toLowerCase().includes('unauthorized')) {
        unauthorizedAttempts += 1;
        if (unauthorizedAttempts >= 3) {
            try { localStorage.removeItem('token'); } catch {}
            // Solo redirige si no estamos ya en /login (evita bucle).
            if (!/\/login$/.test(window.location.pathname)) {
                window.location.href = '/login';
            }
        }
    }
});

export default socket;
